import { PermissionsCustomsFeatures } from '@/constants/permissions';

export const customsRoutes = [
  {
    path: '/customs',
    component: () => import('@/layouts/EmptyRouterView.vue'),
    redirect: { name: 'AmsStatus' },
    children: [
      {
        name: 'AmsStatus',
        path: 'ams',
        meta: {
          pageTitle: 'AMS Status',
          permission: PermissionsCustomsFeatures.AMS,
        },
        component: () => import('@/views/customs/AmsStatusView.vue'),
      },
    ],
  },
];
